import { render, staticRenderFns } from "./DailyStatistics.vue?vue&type=template&id=72b1e886&"
import script from "./DailyStatistics.vue?vue&type=script&lang=js&"
export * from "./DailyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DailyStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports